import { takeLatest, fork, put, call } from 'redux-saga/effects';
import { showSpinner, hideSpinner } from '../../modules/global/actions';
import * as emptySimsActions from './actions';
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas';
import {
  EMPTY_SIMS_FETCH,
  NEW_SUBSCRIPTION,
  FREE_NUMBERS_FETCH,
  ABLE_TO_ACTIVATE_FETCH,
} from './constants';

function* doFetchEmptySims(action) {
  const { id } = action.payload;
  const { response } = yield call(doCallApi, true, ApiRequest.getEmptySims, id);
  if (response) {
    yield put(emptySimsActions.receiveEmptySims(response));
  }
}

function* doFetchFreeNumbers() {
  const { response } = yield call(doCallApi, true, ApiRequest.getFreeNumbers);
  if (response) {
    yield put(emptySimsActions.receiveFreeNumbers(response));
  }
}

function* doNewSubscription(action) {
  yield put(showSpinner());
  if (action.payload.accountType && action.payload.accountType !== 'business') {
    yield call(doCallApi, true, ApiRequest.activateConsumerSubscription, action.payload, action.payload.subscriptionNumber);
  } else {
    yield call(doCallApi, true, ApiRequest.activateBusinessSubscription, action.payload);
  }
  yield put(emptySimsActions.sendNewSubFinished());
  yield put(hideSpinner());
}

function* doAbleToActivate(action) {
  yield put(showSpinner());
  const { id } = action.payload;
  const { response } = yield call(doCallApi, true, ApiRequest.getAbleToActivate, id);
  if (response) {
    yield put(emptySimsActions.receiveAbleToActivate(response));
  }
  yield put(hideSpinner());
}

export function* root() {
  yield fork(takeLatest, NEW_SUBSCRIPTION, doNewSubscription);
  yield fork(takeLatest, EMPTY_SIMS_FETCH, doFetchEmptySims);
  yield fork(takeLatest, FREE_NUMBERS_FETCH, doFetchFreeNumbers);
  yield fork(takeLatest, ABLE_TO_ACTIVATE_FETCH, doAbleToActivate)
}

export default [
  root,
];
